import { paperTheme } from './paper/paperTheme';

export const boxesThemes = paperTheme;
